import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const EditDrivingService = createApi({
	reducerPath: "EditDrivingService",
	tagTypes: "editDta",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
		prepareHeaders: (headers, { getState }) => {
			const reducers = getState();
			const token = reducers?.AuthReducer?.userToken;
			headers.set("authorization", token ? `Bearer ${token}` : "");
			return headers;
		},
	}),
	endpoints: (builder) => {
		return {
			completeYourProfile: builder.mutation({
				query: (profileData) => {
					return {
						url: "user/driver-profile/store",
						method: "POST",
						body: profileData,
					};
				},
				invalidatesTags: ["editDta"],
			}),
			getDriverProfile: builder.query({
				query: () => {
					return {
						url: "user/driver-profile",
						method: "GET",
					};
				},
				providesTags: ["editDta"],
			}),
			editDriverProfile: builder.mutation({
				query: (profileData) => {
					return {
						url: "user/driver-profile/update",
						method: "POST",
						body: profileData,
					};
				},
				invalidatesTags: ["editDta"],
			}),
		};
	},
});

export const {
	useCompleteYourProfileMutation,
	useGetDriverProfileQuery,
	useEditDriverProfileMutation,
} = EditDrivingService;
export default EditDrivingService;
